import React from "react";
import cx from "classnames";
import { Button } from "reactstrap";

import ImgBg from "../../assets/images/data.svg";

import s from "./CodiaxEmptyData.module.scss";

export default function CodiaxEmptyData({ readData }) {
	return (
		<div className={s.root}>
			<Button
				className={cx(s.button, "btn-default dark")}
				color="primary"
				onClick={() => readData()}
			>
				Read Data
			</Button>

			<img src={ImgBg} alt="logo" className={s.logo} />
		</div>
	);
}
